import React, { useState } from 'react'
import styled from 'styled-components'
import MessageLog from '../MessageLog'
import GroupMessageSend from './GroupMessageSend'

const Wrapper = styled.div`
	padding: 24px;
	width: 100%;
`

const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 16px;
`

const Title = styled.h2`
	font-size: 24px;
	font-weight: 700;
	color: #111111;
	margin: 0;
`

const Tabs = styled.div`
	display: flex;
	gap: 8px;
	flex-wrap: wrap;
`

const Tab = styled.button<{ active: boolean }>`
	padding: 8px 12px;
	border-radius: 8px;
	border: 1px solid ${props => (props.active ? '#F78B85' : '#e4e1e1')};
	background-color: ${props => (props.active ? '#F78B85' : '#fff')};
	color: ${props => (props.active ? '#fff' : '#111')};
	cursor: pointer;
	font-weight: 600;

	&:hover {
		background-color: ${props => (props.active ? '#F78B85' : '#fafafa')};
	}
`

export const Message = () => {
	const [tab, setTab] = useState<'log' | 'group'>('log')

	return (
		<Wrapper>
			<Header>
				<Title>메시지</Title>
				<Tabs>
					<Tab active={tab === 'log'} onClick={() => setTab('log')}>
						전송 로그
					</Tab>
					<Tab active={tab === 'group'} onClick={() => setTab('group')}>
						단체 전송
					</Tab>
				</Tabs>
			</Header>
			{tab === 'log' ? <MessageLog /> : <GroupMessageSend />}
		</Wrapper>
	)
}

export default React.memo(Message)
